import { Text } from '@chakra-ui/react'
import * as React from 'react'
import { useColor } from '../../../theme'
import { IFormValidationProps } from '../hooks'

interface IErrorMessageProps extends Pick<IFormValidationProps, 'isDisabled'> {
  children?: React.ReactNode
}

export const ErrorMessage: React.FC<IErrorMessageProps> = ({
  isDisabled,
  children,
}) => {
  const invalidColor = useColor({ nuance: 'red', palette: 'colors' })

  return (
    <Text
      as="span"
      color={invalidColor}
      data-testid="form-component-error-message"
      fontSize="sm"
      marginBottom="0.3rem"
      opacity={isDisabled ? 0.25 : 1}
      paddingTop={1}>
      {children}
    </Text>
  )
}
